import { MsalProvider } from '@azure/msal-react';
import GlobalStyles from '@mui/material/GlobalStyles';
import { ThemeProvider } from '@mui/material/styles';
import ThemeSwitcher from 'components/Dev/ThemeSwitcher';
import UpdateNotification from 'components/Common/UpdateNotification/UpdateNotification';
import { PhoneContextProvider } from 'contexts/PhoneContext';
import ReactGA from 'react-ga4';
import { Helmet } from 'react-helmet-async';
import { BrowserRouter as Router } from 'react-router-dom';
import { isAnalyticsDebug } from '../analytics/analytics';
import AppRoutes from '../routes/AppRoutes';
import { ProvideAuth } from '../routes/utils/useAuth';
// @ts-ignore: side-effect CSS import without type declarations
import './App.css';
import useCurrentTheme from './utils/useCurrentTheme';

let gaInitialized = false

const ensureGaInitialized = () => {
  if (gaInitialized) return

  const gaKey = process.env.REACT_APP_BASE_GA_KEY || ''
  if (!gaKey) return

  ReactGA.initialize(gaKey, {
    gtagOptions: isAnalyticsDebug ? { debug_mode: true } : undefined,
  })
  gaInitialized = true
}

function App({ instance }: any) {
  ensureGaInitialized()

  const theme = useCurrentTheme(location?.host)
  const env = process.env.REACT_APP_B2C_ENVIRONMENTDETAILS
  const browserTabName = env
    ? `${theme.brand.browserTabName} - ${env.toUpperCase()}`
    : theme.brand.browserTabName
  return (
    <Router>
      <MsalProvider instance={instance}>
        <ProvideAuth>
          <ThemeProvider theme={theme}>
            <GlobalStyles
              styles={(t: any) => ({
                ':root': { '--color-bg': t.colorBg || '#fff' },
                'html, body': { fontFamily: t.typography.fontFamily },
                '.MuiPopover-root, .MuiAutocomplete-popper, .MuiTooltip-popper, .MuiPickersPopper-root, [class*="-menuPortal"]':
                  {
                    zoom: 'calc(1 / var(--desktop-zoom-factor, 1))',
                  },
              })}
            />
            <PhoneContextProvider>
              <Helmet>
                <meta charSet="utf-8" />
                <title>{browserTabName}</title>
                <link
                  rel="shortcut icon"
                  // type="image/png"
                  href={theme.brand.favicon}
                  // sizes="16x16"
                />
              </Helmet>
              <AppRoutes />
              <UpdateNotification />
              <ThemeSwitcher />
              {/* <VoiceComponent /> */}
            </PhoneContextProvider>
          </ThemeProvider>
        </ProvideAuth>
      </MsalProvider>
    </Router>
  )
}

export default App
